export default {"src":"/_next/static/media/facebook-f.fd8679db.svg","height":512,"width":320};